import { Spin, Typography } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorMessage, FieldAndLabel, FieldRow, Label } from 'components/common/form-components';
import styled from 'types/theme.types';

type OidcClaimFieldProps = {
  labelId: string;
  value?: string;
  loading?: boolean;
  error?: string;
  dataE2e: string;
};

const OidcClaimField: React.FunctionComponent<OidcClaimFieldProps> = ({ labelId, value, loading, error, dataE2e }) => (
  <FieldRow>
    <FieldAndLabel>
      <Label id={labelId} />
      {loading ? (
        <Spin size="small" />
      ) : (
        <ClaimValue data-e2e={dataE2e} code copyable>
          {value}
        </ClaimValue>
      )}
      <ErrorMessage data-e2e={`${dataE2e}-error`}>{error && <FormattedMessage id={error} />}</ErrorMessage>
    </FieldAndLabel>
  </FieldRow>
);

const ClaimValue = styled(Typography.Text)`
  align-self: flex-start;
`;

export default OidcClaimField;
